export default __webpack_public_path__ + "static/media/client13.ba3e6695.jpg";